import React from 'react'

const Tabs = React.forwardRef(({ className = '', defaultValue, onValueChange, children, ...props }, ref) => {
  const [activeTab, setActiveTab] = React.useState(defaultValue)

  const handleTabChange = (value) => {
    setActiveTab(value)
    if (onValueChange) {
      onValueChange(value)
    }
  }

  const contextValue = {
    activeTab,
    setActiveTab: handleTabChange
  }

  return (
    <div ref={ref} className={className} {...props}>
      {React.Children.map(children, child => {
        if (!React.isValidElement(child)) return child
        return React.cloneElement(child, { tabsContext: contextValue })
      })}
    </div>
  )
})

const TabsList = React.forwardRef(({ className = '', children, tabsContext, ...props }, ref) => (
  <div
    ref={ref}
    className={`inline-flex h-10 items-center justify-center rounded-md bg-gray-100 dark:bg-gray-800 p-1 text-gray-500 dark:text-gray-400 ${className}`}
    {...props}
  >
    {React.Children.map(children, child => {
      if (!React.isValidElement(child)) return child
      return React.cloneElement(child, { tabsContext })
    })}
  </div>
))

const TabsTrigger = React.forwardRef(({ className = '', value, children, tabsContext, ...props }, ref) => (
  <button
    ref={ref}
    className={`inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium ring-offset-white dark:ring-offset-gray-950 transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-400 dark:focus-visible:ring-gray-600 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 ${tabsContext?.activeTab === value
        ? 'bg-white dark:bg-gray-950 text-gray-950 dark:text-gray-50 shadow-sm'
        : 'hover:bg-gray-50 dark:hover:bg-gray-700 hover:text-gray-900 dark:hover:text-gray-100'
      } ${className}`}
    onClick={() => tabsContext?.setActiveTab(value)}
    {...props}
  >
    {children}
  </button>
))

const TabsContent = React.forwardRef(({ className = '', value, children, tabsContext, ...props }, ref) => (
  tabsContext?.activeTab === value ? (
    <div
      ref={ref}
      className={`mt-2 ring-offset-white dark:ring-offset-gray-950 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-400 dark:focus-visible:ring-gray-600 focus-visible:ring-offset-2 ${className}`}
      {...props}
    >
      {children}
    </div>
  ) : null
))

Tabs.displayName = 'Tabs'
TabsList.displayName = 'TabsList'
TabsTrigger.displayName = 'TabsTrigger'
TabsContent.displayName = 'TabsContent'

export { Tabs, TabsContent, TabsList, TabsTrigger }

